import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Axios from 'axios';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import config from '../../../../config';

import {
  ContentButonGroup,
  ContentButon,
  ContentDialog,
  ContainerData,
  ButtonGrupDialog,
} from '../../styledComponents';

const SummaryStep = ({
  token,
  nombreCompletoDistribuidora,
  distribuidora,
  onStart,
  setLoadingFull,
  tipoCambio,
}) => {
  const [cancelSolicitud, setCancelSolicitud] = useState(false);
  const [confirmCancelSolicitud, setConfirmCancelSolicitud] = useState(false);

  const handleOpenCancelVaocuher = () => {
    setCancelSolicitud(true);
  };

  const handleCloseCancelVaucher = () => {
    setCancelSolicitud(false);
  };

  const handleCancelVaucher = async () => {
    try {
      setLoadingFull(true);
      await Axios.post(`${config.api.url}/distribuidoras/cancelar-solicitud`, {
        tokenSolicitud: token,
      });
      setLoadingFull(false);

      setCancelSolicitud(false);
      setConfirmCancelSolicitud(true);
    } catch (error) {
      console.error(error);
    }
  };

  let subTitleTipoCambio = tipoCambio;

  if (tipoCambio === 'seguro') {
    subTitleTipoCambio = 'Proteccion Conmigo';
  } else if (tipoCambio === 'tarjeta') {
    subTitleTipoCambio = 'Tarjeta de débito';
  } else if (tipoCambio === 'celular') {
    subTitleTipoCambio = 'Télefono Celular';
  }

  return (
    <>
      {confirmCancelSolicitud === false && (
        <>
          <ContainerData>
            <h3>{get(distribuidora, 'folio', '')}</h3>
            <div className="numbertwo">{nombreCompletoDistribuidora || ''}</div>
          </ContainerData>
          <h3>Actualización de Datos</h3>
          <h3>{subTitleTipoCambio}</h3>

          <ContentButonGroup>
            <ContentButon>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={onStart}
              >
                Iniciar proceso
              </Button>
            </ContentButon>
            <ContentButon>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                size="large"
                onClick={handleOpenCancelVaocuher}
              >
                Rechazar actualización
              </Button>
            </ContentButon>
          </ContentButonGroup>
        </>
      )}

      {confirmCancelSolicitud === true && (
        <>
          <div className="greeting">Actualización de datos cancelada</div>
          <h2>La actualizacion de datos ha sido cancelada exitosamente.</h2>
        </>
      )}

      <Dialog
        open={cancelSolicitud}
        onClose={handleCloseCancelVaucher}
        maxWidth="sm"
      >
        <IconButton
          style={{
            position: 'absolute',
            top: 5,
            right: 5,
            zIndex: 10,
          }}
          onClick={handleCloseCancelVaucher}
        >
          <CloseIcon />
        </IconButton>
        <ContentDialog>
          <h1>¿Estás seguro de que no quieres el cambio?</h1>
          <h2>Al rechazarlo se cancelará y no podrás solicitarlo de nuevo</h2>
          <ButtonGrupDialog>
            <Button
              color="primary"
              onClick={handleCloseCancelVaucher}
              style={{ textTransform: 'none', marginRight: 15 }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCancelVaucher}
              style={{ textTransform: 'none' }}
            >
              Aceptar
            </Button>
          </ButtonGrupDialog>
        </ContentDialog>
      </Dialog>
    </>
  );
};

SummaryStep.propTypes = {
  token: PropTypes.string,
  nombreCompletoDistribuidora: PropTypes.string,
  distribuidora: PropTypes.object,
  onStart: PropTypes.func,
  setLoadingFull: PropTypes.func,
  tipoCambio: PropTypes.string,
};

SummaryStep.defaultProps = {
  token: '',
  nombreCompletoDistribuidora: '',
  distribuidora: {},
  onStart: () => {},
  setLoadingFull: () => {},
  tipoCambio: '',
};

export default SummaryStep;
